window.smeg = window.smeg || {}
let STORAGE_KEY = `SKU_comparison_storage_${window.smeg.locale}`;

let $comparatorSkuContainer = $(".comparator-sku-container");
let $comparatorContainer = $(".comparator-container");
let $comparatorCheckbox = $(".product-comparison-checkbox");
let $showDifferentAttributeCheckbox = $(".show-different-attributes-comparison-checkbox");
let $comparisonRowToHide = $(".comparison-row-to-hide");
let $categoryLinkContainer = $(".category-link");
let $categoryRemoveProductContainer = $(".remove-product");

function goToComparator() {
    let baseurl = window.smeg.comparisonBaseUrl;
    let skus_url = [];
    $('.comparator-sku-element').each(function(){skus_url.push($(this).attr('data-sku-comparator'))});
    let queryString_sku = "?SKUs=" + skus_url;
    window.location.href = baseurl + queryString_sku;
}

function addToStorage(sku) {
    let existing = localStorage.getItem(STORAGE_KEY);
    existing = existing ? existing.split(',') : [];
    if (existing.length < 3) {
        existing.push(sku);
        localStorage.setItem(STORAGE_KEY, existing.toString());
        manageComparatorBannerVisibility();
    }
    if(sku){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'selezione-prodotto-confronto',
            productCompared: sku,
        });
    }
}

function removeAllSkus(){
    let skus = localStorage.getItem(STORAGE_KEY);
    skus = skus ? skus.split(',') : [];
    for (let i = 0; i < skus.length; i++) {
        removeFromStorage(skus[i]);
    }
}

function removeFromStorage(sku) {
    let existing = localStorage.getItem(STORAGE_KEY);
    existing = existing ? existing.split(',') : [];
    const index = existing.indexOf(sku);
    if (index > -1) {
        existing.splice(index, 1);
    }
    localStorage.setItem(STORAGE_KEY, existing.toString());
    manageComparatorBannerVisibility();
}

function manageComparatorBannerVisibility() {
    let skus = localStorage.getItem(STORAGE_KEY);
    let data = [];
    skus = skus ? skus.split(',') : [];

    $comparatorCheckbox.filter(function () {
        return $.inArray($(this).data("sku"), skus) > -1;
    }).prop('checked', true);

    $comparatorCheckbox.filter(function () {
        return $.inArray($(this).data("sku"), skus) === -1;
    }).prop('checked', false);

    let removeProductLabel = $categoryRemoveProductContainer.data("label");

    $comparatorSkuContainer.html(
        `${skus.map(sku => { data = sku.split('|'); return ` <div class="comparator-sku-element" data-sku-comparator="${data[0]}"><button type="button" aria-label="${removeProductLabel}" onclick="removeFromStorage('${sku}')"/><div class="comparator-img"><img src="${data[1]}" alt=""/></div><div class="comparator-sku">${data[0]}</div></div>`}).join("")}`
    );

    if(skus && skus[0]){
        let firstSkuData = skus[0].split('|');
        if(firstSkuData[2] && firstSkuData[3]){
            let firstCategoryName = firstSkuData[2];
            let firstCategoryUrl = firstSkuData[3];
            let categoryLabel = $categoryLinkContainer.data("label");
            $categoryLinkContainer.html(
                `<a href="${firstCategoryUrl}">${categoryLabel} ${firstCategoryName}</a>`
            );
        }
    }

    if (skus && skus.length !== 0) {
        if (!$comparatorContainer.is(':visible')) {
            setComparatorBottomOffset(0);
            window.addEventListener('scroll', handleStickyComparatorWhenScrolling);
        }
        $comparatorContainer.show();

    } else {
        $comparatorContainer.hide();
        window.removeEventListener('scroll', handleStickyComparatorWhenScrolling);
    }

    if (skus.length === 3) {
        $("input.product-comparison-checkbox:checkbox:not(:checked)").prop("disabled", true);
        
    } else {
        $("input.product-comparison-checkbox:checkbox:not(:checked)").prop("disabled", false);
    }

    if (skus.length >= 2) { 
        $(".btn-comparator").removeAttr("disabled");
    } else {
        $(".btn-comparator").attr("disabled" , true);
    }

    if (skus.length === 3) {
        $(".comparator-msg-first").addClass("hidden");
        $(".comparator-msg-second").addClass("hidden");
        $categoryLinkContainer.addClass("hidden");
    } else if (skus.length === 1) {
        $(".comparator-msg-first").removeClass("hidden");
        $(".comparator-msg-second").addClass("hidden");
        $categoryLinkContainer.removeClass("hidden");
    } else if (skus.length === 2) {
        $(".comparator-msg-first").addClass("hidden");
        $(".comparator-msg-second").removeClass("hidden");
        $categoryLinkContainer.removeClass("hidden");
    }
}

function setComparatorBottomOffset(offset) {
    $comparatorContainer.css('bottom', offset + 'px');
}

function handleStickyComparatorWhenScrolling() {
    let scrollThreshold = $(document).height() - $('.footer').outerHeight();
    let scrollPosition = $(document).scrollTop() + $(window).height();
    let diff = scrollPosition - scrollThreshold;
    if (diff > 0) {
        setComparatorBottomOffset(diff);
    } else {
        setComparatorBottomOffset(0);
    }
}

function onComparatorCheckboxChange(element) {
    const sku = $(element).data("sku");
    if (element.checked) {
        addToStorage(sku);
    } else {
        removeFromStorage(sku)
    }
}

function activeSubTable(el) {
    if (!el) {
        return;
    }
    const clickedID = `#${el}`;
    // rimosso su task SSD-3542 resetSubTables();
    const targetHeader = document.querySelector(clickedID).parentElement.classList;
    const targetRows = [...document.querySelectorAll(`tr[data-target='${el}']`)];
    const isSubTableActive = targetHeader.contains('active');
    // Se la sottotabella è già attiva, la disattiviamo, altrimenti l'attiviamo
    if (isSubTableActive) {
        targetHeader.remove('active');
        targetRows.forEach(r => r.classList.add('d-none'));
    } else {
        targetHeader.add('active');
        targetRows.forEach(r => r.classList.remove('d-none'));
    }
}


function initSubTable() {
    const headerClass='.js_subTable-header';
    const headerList = [...document.querySelectorAll(headerClass)];
    headerList.map(h => {
        h.addEventListener("click", function(e){
            const clickedEl = e?.target?.id;
            activeSubTable(clickedEl)
        });
    })
}

function reduceComparator() {
    const $header = $('.comparator-header');
    const $content = $('.comparator-container');
    const $startContentHeight = $content.height() + 115;
    let $contentHeight = $content.height();
    let $headerHeight = $header.height() + 20;

    $header.on('click', function(){
        if($headerHeight < 20) {
            $headerHeight = 60;
        }
        if($contentHeight === $headerHeight) {
            $content.animate({height:$startContentHeight});
            $contentHeight = $startContentHeight;
            $headerHeight = $header.height() + 20;
            $content.find(".comparator-header").addClass("open")
        } else {
            $content.animate({height: $headerHeight});
            $contentHeight = $headerHeight;
            $headerHeight = $header.height() + 20;
            $content.find(".comparator-header").removeClass("open")
        }
        
    })

    $header.on("keydown", function(e) {
        if (e.key === 'Enter') {
            $(this).click();
        }
    })
}

$(document).ready(function () {
    //-- PRODUCT COMPARISON SECTION
    $comparatorCheckbox.change(function () {
        onComparatorCheckboxChange(this)
    });

    $showDifferentAttributeCheckbox.change(function () {
        if (this.checked) {
            $comparisonRowToHide.attr('style','display:none !important');
        } else {
            $comparisonRowToHide.css('display', '')
        }
    });

    manageComparatorBannerVisibility();
    initSubTable();
    reduceComparator();
});
